<template>
  <div class="referrals-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ReferralsLayout"
}
</script>

<style scoped>
.referrals-layout {
  padding: 20px;
}
</style>
